import React from 'react';
import styles from './styles/styles.module.scss';

import ProfileIcon from '../ProfileIcon';

class UserInfo extends React.Component {
  render() {
    return (
      <div className={`d-flex flex-row ${styles.userInfo} ${this.props.active ? styles.hover : ''}`}>
        <div className="pr-2">
          <ProfileIcon link={this.props.link} imagePath={this.props.imagePath} />
        </div>
        <div>
          <div className={styles.name}>{this.props.name}</div>
          <div className={styles.reputation}>{this.props.reputation}</div>
        </div>
        <div className={styles.indicatorContainer}>{this.props.indicator}</div>
      </div>
    );
  }
}

export default UserInfo;
